var MAX_PICTURE_SIZE = 5 * 1024 * 1024;
var ProfilePhotoController = (function () {
    function ProfilePhotoController($filter, API_END_POINT, UserService, NotificationCenter) {
        this.$filter = $filter;
        this.$api = API_END_POINT;
        this.$auth = 'Bearer ' + UserService.getToken();
        this.$notifications = NotificationCenter;
    }
    ProfilePhotoController.prototype.$onInit = function () {
        this.flowOptions = {
            target: "".concat(this.$api, "/api/profile/").concat(this.activeProfile.type, "/").concat(this.activeProfile.profile._id, "/picture-upload"),
            simultaneousUploads: 1,
            allowDuplicateUploads: true,
            chunkSize: 1024 * 1024,
            headers: {
                Authorization: this.$auth,
            },
        };
    };
    ProfilePhotoController.prototype.$onChanges = function (changes) {
        if (changes.activeProfile && !changes.activeProfile.isFirstChange()) {
            this.flowOptions.target = "".concat(this.$api, "/api/profile/").concat(changes.activeProfile.currentValue.type, "/").concat(this.activeProfile.currentValue.profile._id, "/picture-upload");
        }
    };
    ProfilePhotoController.prototype.onUploadSubmit = function ($flow) {
        var _this = this;
        $flow.files.forEach(function (file) {
            if (file.size > MAX_PICTURE_SIZE) {
                _this.$notifications.show({
                    title: 'My Profile',
                    avatar: _this.$filter('scImage')(_this.activeProfile.profile.imageUrl, _this.activeProfile.type),
                    text: 'The image is too big.',
                });
                $flow.removeFile(file);
            }
        });
        if ($flow.files.length) {
            Object.assign($flow.opts, this.flowOptions);
            $flow.upload();
        }
    };
    ProfilePhotoController.prototype.onFileProgress = function (_file) {
    };
    ProfilePhotoController.prototype.onFileComplete = function (file, message) {
        Object.assign(this.activeProfile.profile, JSON.parse(message));
        this.$notifications.show({
            title: 'My Profile',
            avatar: this.$filter('scImage')(this.activeProfile.profile.imageUrl, this.activeProfile.type),
            text: 'Picture upload successful!',
        });
    };
    ProfilePhotoController.prototype.onFileError = function (_file, _message) {
        this.$notifications.show({
            title: 'My Profile',
            avatar: this.$filter('scImage')(this.activeProfile.profile.imageUrl, this.activeProfile.type),
            text: 'Unable to upload the picture.',
        });
    };
    return ProfilePhotoController;
}());
angular.module('app.profile').component('profilePhoto', {
    templateUrl: 'profile/components/photo.html',
    controller: ProfilePhotoController,
    bindings: {
        activeProfile: '<',
        editable: '<',
        editableForm: '<',
    },
});
;